var angular = require('angular');

var Delivery = require('js/lib/delivery');
var Customer = require('js/lib/customer');
var Route = require('js/lib/route');
var File = require('js/lib/file');
var Distribution = require('js/lib/distribution');
var DistributionCustomer = require('js/lib/distributionCustomer');
var RoutePlan = require('js/lib/routePlan');
var DriverUser = require('js/lib/driverUser');
var Downtime = require('js/lib/downtime');
var toObject = require('js/lib/util').toObject;
var mapDrivers = require('js/lib/util').mapDrivers;

load.$inject = ['$rootScope', '$filter', '$q', '$timeout', '$window', 'http', 'pusher', 'router', 'storage'];

function load($rootScope, $filter, $q, $timeout, $window, http, pusher, router, storage) {

  var self = this;
  var cache = {};

  // Reset the cache and pusher subscriptions when switching between a distribution page and a plan page
  $rootScope.$on('$locationChangeStart', function(event, newUrl, oldUrl) {

    var isDistributionPage = function(url) {
      return url.indexOf('#/distribution') !== -1;
    };

    if (isDistributionPage(newUrl) !== isDistributionPage(oldUrl)) {
      pusher.unsubscribeAll();
      ['distributions', 'distribution', 'routePlans', 'routePlan', 'drivers'].forEach(resetCache);
    }
  });

  var resetCache = function(key) {
    cache[key] = null;
    $rootScope[key] = null;
  };

  var loadAndCache = function(url, key, transformFunc) {

    var success = function(data) {
      cache[key] = transformFunc(data);
      $rootScope[key] = cache[key];
      return cache[key];
    };

    if (cache[key]) {
      $rootScope[key] = cache[key];
      return $q.when(cache[key]);
    } else {
      return http.get(url).then(success);
    }
  };

  var loadAndCacheAdvanced = function(url, cacheKey, rootScopeKey, transformFunc) {

    var success = function(data) {
      cache[cacheKey] = transformFunc(data);
      $rootScope[rootScopeKey] = cache[cacheKey];
      return cache[cacheKey];
    };

    if (cache[cacheKey]) {
      $rootScope[rootScopeKey] = cache[cacheKey];
      return $q.when(cache[cacheKey]);
    } else {
      return http.get(url).then(success);
    }
  };

  var updateCachedRoutePlan = function(routePlanId, updateCallback) {
    cache.routePlans && cache.routePlans.forEach(function(routePlan) {
      if (routePlan.id === routePlanId) {
        updateCallback(routePlan);
      }
    });

    if (cache.routePlan && cache.routePlan.id === routePlanId) {
      updateCallback(cache.routePlan);
    }
  };

  this.customerSystemsForCompany = function(aCompanyId) {
    var url = companyId()
      ? ['company', aCompanyId, 'customerSystems']
      : ['customerSystem', customerSystemIdsStr(), 'company', aCompanyId, 'customerSystems'];
    var rootScopeKey = 'customerSystems';
    var cacheKey = 'customerSystems-' + aCompanyId;

    loadAndCacheAdvanced(url, cacheKey, rootScopeKey, toObject);
  };

  this.customerSystems = function() {
    var url = null;
    if (companyId()) {
      url = ['company', companyId(), 'customerSystems'];
    } else if (customerSystemIdsStr()) {
      url = ['customerSystem', customerSystemIdsStr(), 'customerSystems'];
    } else {
      $rootScope['customerSystems']=[];
      return;
    }

    loadAndCache(url, 'customerSystems', toObject);
  };

  this.users = function() {
    var toDriverUser = function(data) {
      return data.map(function(driver) {
        return new DriverUser(driver);
      });
    };

    if (companyId() && $rootScope.auth.roles.planner) {
      loadAndCache(['userAdmin', 'company', companyId(), 'users'], 'users', toDriverUser);
    } else {
      $rootScope.users = [];
    }
  };

  this.driverUsers = function() {
    var toDriverUser = function(data) {
      return data.map(function(driver) {
        return new DriverUser(driver);
      });
    };

    if (companyId() && $rootScope.auth.roles.planner) {
      loadAndCache(['userAdmin', 'company', companyId(), 'drivers'], 'driverUsers', toDriverUser);
    } else {
      $rootScope.driverUsers = [];
    }
  };

  this.drivers = function(companyId) {
    if (companyId) {
      loadAndCache(['company', companyId, 'drivers'], 'drivers', mapDrivers);
    } else {
      $rootScope.drivers = [];
    }
  };

  this.companies = function() {
    if ($rootScope.auth.roles.di || ($rootScope.auth.roles.planner && $rootScope.auth.companyIds.length > 1)) {
      loadAndCache(['companies'], 'companies', toObject);
    } else {
      $rootScope.companies = [];
    }
  };

  this.settings = function() {
    if ($rootScope.auth.roles.planner && companyId()) {
      loadAndCache(['company', companyId(), 'settings'], 'settings', function(data) { return data; });
    } else if (($rootScope.auth.roles.client || $rootScope.auth.roles.customerService) && customerSystemIdsStr()) {
      loadAndCache(['customerSystem', customerSystemIdsStr(), 'settings'], 'settings', function(data) { return data; });
    } else {
      $rootScope.settings = [];
    }
  };

  this.distributions = function() {

    var toDistribution = function(data) {
      return data.map(function(distribution) {
        return new Distribution(distribution);
      });
    };

    var subscribeActiveDistributionsToPusher = function(distributions) {
      $filter('activeRoutePlans')(distributions).forEach(function(distribution) {
        distribution.distrNos.forEach(function(distrNo) {
          distribution.distrNo = distrNo;
          subscribeDistributionToPusher(distribution);
        });
      });
    };

    var url = ['customerSystem', customerSystemIdsStr(), 'distributions'];

    loadAndCache(url, 'distributions', toDistribution)
      .then(subscribeActiveDistributionsToPusher);
  };

  this.distribution = function(date, distrNo, ignoreCache) {

    var toDistribution = function(data) {
      return new Distribution(data);
    };

    var url = ['customerSystem', customerSystemIdsStr(), 'distribution', date, distrNo];

    if (ignoreCache) {
      return http.get(url).then(toDistribution);
    }

    if (cache.distribution && (cache.distribution.date !== date || cache.distribution.distrNo !== distrNo)) {
      cache.distribution = null;
    }

    return loadAndCache(url, 'distribution', toDistribution)
      .then(subscribeDistributionToPusher);
  };

  this.distributionCustomers = function(distribution, type, query) {
    var url = ['customerSystem', customerSystemIdsStr(), 'distribution', distribution.date, distribution.distrNo, type];
    var params = query ? { q: query } : null;

    return http.get(url, params).then(function(data) {
      return data.map(function(customer) {
        return new DistributionCustomer(customer, distribution);
      });
    });
  };

  this.routePlans = function() {

    var toRoutePlan = function(data) {
      return data
        .filter(function(routePlan) {
          return routePlan.statusId !== 6;  // 6 == deleted
        })
        .map(function(routePlan) {
          return new RoutePlan(routePlan, true);
        });
    };

    var subscribeActiveRoutePlansToPusher = function(routePlans) {
      $filter('activeRoutePlans')(routePlans).forEach(function(routePlan) {
        subscribeRoutePlanToPusher(routePlan);
      });
    };

    var url = null;
    if (companyId()) {
      url = ['company', companyId(), 'routePlans'];
    } else if (customerSystemIdsStr()) {
      url = ['customerSystem', customerSystemIdsStr(), 'routePlans'];
    } else {
      $rootScope['routePlans']=[];
      return;
    }

    if (! ($rootScope.auth.roles.planner || $rootScope.auth.roles.clientPlus)) url.push('published');

    loadAndCache(url, 'routePlans', toRoutePlan)
      .then(subscribeActiveRoutePlansToPusher);
  };

  this.routePlan = function(routePlanId) {

    var toRoutePlan = function(data) {
      return new RoutePlan(data);
    };

    var url;

    if ($rootScope.auth.roles.planner) {
      url = ['routePlan', routePlanId];
    } else if (companyId()) {
      url = ['company', companyId(), 'routePlan', routePlanId];
    } else {
      url = ['customerSystem', customerSystemIdsStr(), 'routePlan', routePlanId];
    }

    if (cache.routePlan && cache.routePlan.id !== +routePlanId) {
      cache.routePlan = null;
    }

    return loadAndCache(url, 'routePlan', toRoutePlan)
      .then(subscribeRoutePlanToPusher);
  };

  var shouldReloadRoutePlan = function(statusId) {
    // 0 == created/imported, 5 == optimized, 11 == routesimported
    return statusId === 0 || statusId === 5 || statusId === 11;
  };

  var toNotification = function(data) {
    // Hack it so Pusher-data converts to documented notification-object
    data.timestampSent = new Date();
    data.customerId = data.id;
    data.id = null;

    return data;
  };

  var verifyAccess = function(custSysId) {
    // If client: Check if client has no access to customer system
    return ! ($rootScope.auth.roles.client && customerSystemId() && customerSystemId() !== custSysId);
  };

  var subscribeDistributionToPusher = function(distribution) {

    var routePlanStatusUpdated = function(routePlanId, data) {

      var findRoutePlan = function(distribution) {
        return distribution && distribution.findRoutePlan(routePlanId);
      };

      var distributionIsCached = function() {
        return cache.distribution &&
          cache.distribution.date === distribution.date &&
          cache.distribution.distrNo === distribution.distrNo;
      };

      var replaceDistribution = function() {
        cache.distribution = null;
        return self.distribution(distribution.date, distribution.distrNo);
      };

      var loadDistribution = function() {
        return self.distribution(distribution.date, distribution.distrNo, true);
      };

      var updateRoutePlanCounts = function(newDistribution) {
        var oldDistribution = cache.distributions && cache.distributions.filter(findRoutePlan)[0];
        var oldRoutePlan = findRoutePlan(oldDistribution);
        var newRoutePlan = findRoutePlan(newDistribution);

        oldRoutePlan && newRoutePlan && oldRoutePlan.updateCounts(newRoutePlan);
      };

      var updateRoutePlanStatus = function(statusId) {
        var oldRoutePlan = findRoutePlan(cache.distribution);

        oldRoutePlan && oldRoutePlan.updateStatus(statusId);
      };

      if (shouldReloadRoutePlan(data.statusId)) {
        if (distributionIsCached()) {
          replaceDistribution().then(updateRoutePlanCounts);
        } else if (cache.distributions) {
          loadDistribution().then(updateRoutePlanCounts);
        }
      } else {
        updateRoutePlanStatus(data.statusId);
        $rootScope.$apply();
      }
    };

    var setPublishedStateUpdated = function(publishedState, data) {
      [].concat(cache.distribution, cache.distributions).forEach(function(distribution) {
        var routePlan = distribution && distribution.findRoutePlan(data.id);
        if (routePlan) routePlan.published = publishedState;
      });

      $rootScope.$apply();
    };

    var addCustomerNotification = function(data) {
      if (cache.distribution) {
        cache.distribution.addCustomerNotification(data.id, toNotification(data));
        $rootScope.$apply();
      }
    };

    var updateCustomerImage = function(data) {
      if (cache.distribution) {
        cache.distribution.updateCustomerImage(data.id, data);
        $rootScope.$apply();
      }
    };

    var updateCallLog = function(data) {
      if (cache.distribution) {
        cache.distribution.updateCustomerCallLog(data.id, data.driverUsername, data.timestampCalled);
        $rootScope.$apply();
      }
    };

    var updateCustomerClientTime = function(data) {
      if (cache.distribution) {
        cache.distribution.updateCustomerClientTime(data.id, data.clientSideTimestampDone);
        $rootScope.$apply();
      }
    };

    var updateDelivery = function(data) {
      if (! verifyAccess(data.customerSystemId)) {
        return;
      }

      if (! cache.distribution || ! cache.distribution.customers) {
        // We're not on the search or deviations page
        return;
      }

      var customer = cache.distribution.findCustomer(data.customerId);
      var status = new Delivery({ deliveryStatus: data.statusId }, {}).status;

      if (customer) {
        http.get(['delivery', data.id]).then(customer.updateDelivery.bind(customer));
      } else if (status === 'deviation' && router.page() === 'distribution/deviations') {
        http.get(['distributionCustomer', data.customerId]).then(function(data) {
          if (cache.distribution && router.page() === 'distribution/deviations') {
            customer = new DistributionCustomer(data, cache.distribution);
            cache.distribution.addCustomer(customer);
          }
        });
      }
    };

    var deleteDelivery = function(data) {
      if (! verifyAccess(data.customerSystemId)) {
        return;
      }

      var customer = cache.distribution.findCustomer(data.customerId);
      customer.deleteDelivery(data.id);
      $rootScope.$apply();
    };

    var updateRoute = function(data) {
      http.get(['customerSystem', customerSystemIdsStr(), 'distributionRoute', data.id]).then(function(data) {
        var route = cache.distribution && cache.distribution.findRoute(data.id);
        if (route) route.update(data, cache.distribution);
      });
    };

    distribution.routePlans.forEach(function(routePlan) {
      pusher.subscribeRoutePlan(routePlan, {
        statusUpdated: routePlanStatusUpdated.bind(self, routePlan.id),
        published: setPublishedStateUpdated.bind(self, true),
        unpublished: setPublishedStateUpdated.bind(self, false),
        customerClientTimeUpdated: updateCustomerClientTime,
        customerNotified: addCustomerNotification,
        customerImageUpdated: updateCustomerImage,
        customerCallLogUpdated: updateCallLog,
        deliveryUpdated: updateDelivery,
        distributionRouteUpdated: updateRoute,
        deliveryDeleted: deleteDelivery
      });
    });

    return distribution;
  };

  var subscribeRoutePlanToPusher = function(routePlan) {

    var updateRoutePlanStatus = function(data) {
      if (shouldReloadRoutePlan(data.statusId)) {
        self.reloadRoutePlan(routePlan.id, true);  // Fetch the generated routes or the added customers
      } else {
        updateCachedRoutePlan(routePlan.id, function(routePlan) {
          routePlan.statusId = data.statusId;
          if (data.placeInOptimizeQueue)
            routePlan.placeInOptimizeQueue = data.placeInOptimizeQueue;
        });
      }
      $rootScope.$apply();
    };

    var setPublishedStateUpdated = function(publishedState, data) {
      updateCachedRoutePlan(routePlan.id, function(routePlan) {
        routePlan.published = publishedState;
      });

      if (cache.routePlan && cache.routePlan.id === routePlan.id && publishedState) {
        $rootScope.$emit('published');
      }

      $rootScope.$apply();
    };

    var updateFileStatus = function(data) {
      if (! cache.routePlan || cache.routePlan.id !== routePlan.id) return;

      var file = cache.routePlan.findFile(data.id);
      if (file) {
        file.progress = data.progress;

        if (data.progress === 100) {
          file.status = 2;
          self.reloadRoutePlan(routePlan.id);
        } else {
          file.status = 1;
        }

        $rootScope.$apply();
      }
    };

    var updateCustomerClientTime = function(data) {
      if (! cache.routePlan) return;

      cache.routePlan.updateCustomerClientTime(data.id, data.clientSideTimestampDone);
      $rootScope.$apply();
    };

    var updateCustomerNotification = function(data) {
      if (! cache.routePlan) return;

      cache.routePlan.updateNotification(toNotification(data));
      $rootScope.$apply();
    };

    var updateCustomerImage = function(data) {
      if (! cache.routePlan) return;

      cache.routePlan.updateCustomerImage(data.id, data.imageUrl);
      $rootScope.$apply();
    };

    var updateCallLog = function(data) {
      if (! cache.routePlan) return;

      cache.routePlan.updateCustomerCallLog(data.id, data.driverUsername, data.timestampCalled);
      $rootScope.$apply();
    };

    var updateRoute = function(data) {
      http.get(['route', data.id]).then(function(data) {
        if (! cache.routePlan) return;

        // Preserve some data previously extracted from customers
        var oldRoute = cache.routePlan.findRoute(data.id);
        if (oldRoute)
          data.customerTimeWindows = oldRoute.customerTimeWindows;

        cache.routePlan.updateRoute(new Route(data, []));
        $rootScope.$emit('routeUpdated', data.id);
      });
    };

    var updateRouteDeliveries = function(data) {
      var url = companyId()
        ? ['company', companyId(), 'route', data.id]
        : ['customerSystem', customerSystemIdsStr(), 'route', data.id];

      http.get(url).then(function(data) {
        data.forEach(function(del) {
          var customer = cache.routePlan && cache.routePlan.findCustomer(del.customerId);
          var delivery = customer && new Delivery(del, customer);

          if (delivery) {
            cache.routePlan.updateDelivery(delivery);
            $rootScope.$emit('deliveryStatusUpdated', delivery);
          }
        });
      });
    };

    var updateDeliveryEstimates = function(data) {
      if (cache.routePlan) {
        http.get(['route', data.id, 'estimates']).then(function(data) {
          cache.routePlan && cache.routePlan.updateDeliveryEstimates(data);
        });
      }
    };

    var updateRouteOptimization = function(data) {
      var routeId = data.id;
      var statusId = data.statusId;
      if (cache.routePlan) {
        var route = cache.routePlan.findRoute(routeId);

        if (! cache.routePlan.published || route.reserved) {
          route.updateRouteOptimizationStatus(statusId);
          $rootScope.$apply();

          if (statusId === 0) {
            // Refresh order for content on route
            http.get(['route', routeId, 'customerSequence']).then(function(data) {
              cache.routePlan.updateCustomerSequence(routeId, data);
              route.resetStats();
              $rootScope.$emit('routeSequenceUpdated', routeId);
            });
          }
        }
      }
    };

    var updateDriverPosition = function(data) {
      var route = cache.routePlan && cache.routePlan.findRoute(data.id);
      if (route) {
        route.updateDriverPosition(data.latitude, data.longitude);
        $rootScope.$emit('driverPositionUpdated', route);
      }
    };

    var updateDelivery = function(data) {
      if (! verifyAccess(data.customerSystemId)) {
        return;
      }

      http.get(['delivery', data.id]).then(function(data) {
        var customer = cache.routePlan && cache.routePlan.findCustomer(data.customerId);
        var delivery = customer && new Delivery(data, customer);

        if (delivery) {
          cache.routePlan.updateDelivery(delivery);
          $rootScope.$emit('deliveryStatusUpdated', delivery);
        }
      });
    };

    var deleteDelivery = function(data) {
      if (! verifyAccess(data.customerSystemId)) {
        return;
      }

      cache.routePlan.deleteDelivery(data.id, data.customerId);
      $rootScope.$apply();
    };

    pusher.subscribeRoutePlan(routePlan, {
      statusUpdated: updateRoutePlanStatus,
      published: setPublishedStateUpdated.bind(self, true),
      unpublished: setPublishedStateUpdated.bind(self, false),
      fileUpdated: updateFileStatus,
      customerClientTimeUpdated: updateCustomerClientTime,
      customerNotified: updateCustomerNotification,
      customerImageUpdated: updateCustomerImage,
      customerCallLogUpdated: updateCallLog,
      routeUpdated: updateRoute,
      routeDeliveriesUpdated: updateRouteDeliveries,
      estimatesOnRouteUpdated: updateDeliveryEstimates,
      routeOptimizationStatusUpdated: updateRouteOptimization,
      routePositionUpdated: updateDriverPosition,
      deliveryUpdated: updateDelivery,
      deliveryDeleted: deleteDelivery
    });

    return routePlan;
  };

  var subscribeSystemToPusher = function(downtime) {

    var updateDowntime = function(data) {
      cache['downtime'] = new Downtime(JSON.parse(data), storage);
      $rootScope.downtime = cache['downtime'];
    };

    pusher.subscribeSystem({
      downtimeUpdated: updateDowntime
    });

    return downtime;
  };

  this.saveRoutePlan = function(routePlan) {
    return http.post('routePlan', routePlan).then(function(data) {
      var routePlan = new RoutePlan(data, true);

      cache.routePlans && cache.routePlans.push(routePlan);
      subscribeRoutePlanToPusher(routePlan);
      $rootScope.routePlans = cache.routePlans;

      return routePlan;
    });
  };

  this.saveRoute = function(route) {
    var url = ['route', route.id];
    var data = angular.extend({}, route);
    var oldRoute = cache.routePlan.findRoute(route.id);

    delete data.id;
    delete data.autoAssignedDriver;

    if (oldRoute.pickupLocationId !== route.pickupLocationId ||
        oldRoute.overriddenStart !== route.overriddenStart) {
      oldRoute.resetStats();
    }

    return http.post(url, data).then(function() {
      route = angular.extend({}, oldRoute, route);

      // Preserve some data previously extracted from customers
      route.customerTimeWindows = oldRoute.customerTimeWindows;

      // Reset auto-flagg only if driver changed
      route.autoAssignedDriver = route.autoAssignedDriver && route.driverUsername === oldRoute.driverUsername;

      cache.routePlan.updateRoute(new Route(route, []));
      $rootScope.$emit('routeUpdated', route.id);
    });
  };

  this.addRoute = function(routePlanId, route) {
    var url = ['routePlan', routePlanId, 'route'];

    return http.post(url, route).then(function() {
      $window.location.reload(true);
    });
  };

  this.startOptimization = function(routePlanId, data) {
    var url = ['routePlan', routePlanId, 'startOptimize'];

    return http.post(url, data, [417]).then(function() {
      updateCachedRoutePlan(routePlanId, function(routePlan) {
        routePlan.date = data.date.slice(0, 10);
        if (! routePlan.statusId) {
          routePlan.statusId = 1;  // in the Spider queue
        }
      });
    });
  };

  this.createSuggestedRoutes = function(routePlanId, data) {
    var url = ['routePlan', routePlanId, 'createSuggestedRoutes'];

    return http.post(url, data, [417]).then(function() {
      updateCachedRoutePlan(routePlanId, function(routePlan) {
        routePlan.date = data.date.slice(0, 10);
        if (! routePlan.statusId) {
          routePlan.statusId = 9;  // in queue
        }
      });
    });
  };

  this.saveRouteSequence = function(routePlanId, routes, reloadPlan) {
    var data = routes.map(function(route) {
      return {
        routeId: route.id,
        stopLocationIdSequence: route.stopLocations
          .sort(function(stop1, stop2) {
            return stop1.routeSequence - stop2.routeSequence;
          })
          .map(function(stop) {
            return stop.id;
          })
      };
    });

    routes.forEach(function(route) {
      route.resetStats();
    });

    // console.log('saveRouteSequence', data.length, 'routes', data.map(function(route) {
    //   return route.routeId + ' hadde ' + route.stopLocationIdSequence.reduce(function(count, stopId){ return count + 1 }, 0) + ' stopp';
    // }).join(', '));

    http.post(['routePlan', routePlanId, 'routeSequences'], data).then(function() {
      if (reloadPlan) self.reloadRoutePlan(routePlanId);
    });
  };

  this.deleteRoutes = function(routePlanId) {
    updateCachedRoutePlan(routePlanId, function(routePlan) {
      routePlan.statusId = 0;
      routePlan.routes = [];
      routePlan.routeCount = 0;
      routePlan.stopLocationCount = 0;
    });

    http.delete(['routePlan', routePlanId, 'routes']);
  };

  this.deleteRoutePlan = function(routePlanId) {
    if (cache.routePlans) {
      for (var i = 0; i < cache.routePlans.length; i++) {
        if (cache.routePlans[i].id === routePlanId) {
          cache.routePlans.splice(i, 1);
          break;
        }
      }
    }
    if (cache.distribution) {
      // console.log('cache.distribution', cache.distribution);
      for (var i = 0; i < cache.distribution.routePlans.length; i++) {
        if (cache.distribution.routePlans[i].id === routePlanId) {
          cache.distribution.routePlans.splice(i, 1);
          break;
        }
      }
    }

    if (cache.routePlan && cache.routePlan.id === routePlanId) {
      cache.routePlan = null;
    }

    http.delete(['routePlan', routePlanId]);
  };

  this.deleteRoute = function(routeId) {
    http.delete(['route', routeId]).then(function() {
      updateCachedRoutePlan(cache.routePlan.id, function(routePlan) {
        if (routePlan.routes) {
          // "routes" exists for "cache.routePlan", but not for plan in "cache.routePlans"
          routePlan.routes = routePlan.routes.filter(function(route) {
            return route.id !== routeId;
          });
        }
        routePlan.routeCount--;
      });
    });
  };

  this.enableDriverInputForRoutePlan = function(routePlanId) {
    var url = ['routePlan', routePlanId, 'readyForDriverInput'];

    return http.post(url).then(function() {
      self.reloadRoutePlan(routePlanId);
    });
  };

  this.publishRoutePlan = function(routePlanId) {
    var url = ['routePlan', routePlanId, 'publish'];

    return http.post(url).then(function() {
      self.reloadRoutePlan(routePlanId);
    });
  };

  this.unpublishRoutePlan = function(routePlanId) {
    var url = ['routePlan', routePlanId, 'unpublish'];

    return http.post(url).then(function() {
      self.reloadRoutePlan(routePlanId);
    });
  };

  this.reloadRoutePlan = function(routePlanId, force) {

    var updateRoutePlans = function(routePlan) {
      cache.routePlans && cache.routePlans.forEach(function(rp) {
        if (rp.id === routePlanId) {
          angular.extend(rp, new RoutePlan(routePlan, true));
        }
      });
    };

    if (! cache.routePlan || cache.routePlan.id === routePlanId) {
      cache.routePlan = null;
      return this.routePlan(routePlanId).then(function(routePlan) {
        updateRoutePlans(routePlan);
        return routePlan;
      });
    } else if (force) {
      cache.routePlans = null;
      this.routePlans();
      $timeout(function() {
        $rootScope.$apply();
      });
    }
  };

  this.createFile = function(routePlanId, customerSystemId, name) {

    var addFile = function(data) {
      var file = new File(data);

      updateCachedRoutePlan(routePlanId, function(routePlan) {
        routePlan.files && ! routePlan.findFile(file.id) && routePlan.files.push(file);
      });

      return file;
    };

    var url = ['routePlan', routePlanId, 'customerSystem', customerSystemId];

    return http.post(url, { name: name }).then(addFile);
  };

  this.uploadFile = function(fileId, file) {
    // 400 Bad request / 504 Gateway timeout / -1 Network error (probably)
    return http.postMultipart(['file', fileId], { file: file }, [400, 504, -1]);
  };

  this.deleteFile = function(file) {
    $rootScope.routePlan = null;
    http.delete(['file', file.id])
      .then(this.reloadRoutePlan.bind(this, file.routePlanId));
  };

  this.deleteCustomer = function($scope, customer) {
    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
    if (currentPlanId) {
      $scope.routePlan = null; // To get spinner
      http.delete(['customer', customer.id]).then(function () {
        cache.routePlans = null;
        cache.routePlan = null;
        self.reloadRoutePlan(currentPlanId).then(function (routePlan) {
          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
            $scope.routePlan = routePlan;
          }
        });
      });
    }
  };

  this.cancelCustomer = function($scope, customerId) {
    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
    if (currentPlanId) {
      $scope.routePlan = null; // To get spinner
      return http.post(['customer', customerId, 'cancel']).then(function () {
        cache.routePlans = null; // To be sure that counts on plan are updated
        cache.routePlan = null;
        self.reloadRoutePlan(currentPlanId).then(function (routePlan) {
          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
            $scope.routePlan = routePlan;
          }
        });
      });
    }
  };

  this.saveCustomer = function($scope, customer) {
    var currentPlanId = $scope.routePlan && $scope.routePlan.id;
    if (currentPlanId) {
      $scope.routePlan = null; // To get spinner
      return http.post(['routePlan', 'customer'], customer).then(function() {
        cache.routePlans = null; // To be sure that counts on plan are updated
        cache.routePlan = null;
        self.reloadRoutePlan(currentPlanId).then(function(routePlan) {
          if (currentPlanId === routePlan.id) { // Double-check that we still are on same plan, and havn't navigated to another
            $scope.routePlan = routePlan;
          }
        });
      });
    }
  };

  this.saveDriverUser = function(user) {
    var urlArr = ['userAdmin', 'company', companyId(), 'driver'];
    if (!user.isNewUser)
      urlArr.push(user.userName);

    var cleanedUser = {
      userName: user.userName,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      email: user.email,
      active: user.active,
      language: user.language,
    };

    return http.post(urlArr, cleanedUser, [400]);
  };

  this.generateAndSendPasswordForDriverUser = function(username) {
    return http.post(['userAdmin', 'company', companyId(), 'driver', username, 'generatePassword']);
  };

  this.optimizeRoute = function(routeId) {
    return http.post(['route', routeId, 'queueForOptimization']);
  };

  this.optimizeRouteWithOptions = function(routeId, firstStopId, lastStopId) {
    return http.post(['route', routeId, 'queueForOptimization'], {
      forcedFirstStopLocationId: firstStopId,
      forcedLastStopLocationId: lastStopId
    });
  };

  this.optimizeAllNeededRoutes = function(routePlanId) {
    return http.post(['routePlan', routePlanId, 'queueAllNeededRoutesForOptimization']);
  };

  this.clearTimeWindowsAndOptimizeRoute = function(routeId) {
    return http.post(['route', routeId, 'clearTimeWindowsAndQueueForOptimization']);
  };

  var companyId = function() {
    return $rootScope.auth.companyId || $rootScope.auth.companyIds && $rootScope.auth.companyIds.length && $rootScope.auth.companyIds[0] || 0;
  };

  var customerSystemId = function() {
    return $rootScope.auth.customerSystemIds && $rootScope.auth.customerSystemIds[0];
  };

  var customerSystemIdsStr = function() {
    if ($rootScope.auth.customerSystemIds) {
      return $rootScope.auth.customerSystemIds.reduce(function(idsStr, id) {
        if (idsStr) idsStr += '-';
        return idsStr + id;
      }, '');
    }
    return $rootScope.auth.customerSystemIds;
  };

  this.getDowntime = function(){
    var toDowntime = function(data) {
      return new Downtime(data, storage);
    };

    return loadAndCache('downtime', 'downtime', toDowntime)
      .then(subscribeSystemToPusher);
  };

  this.saveDowntime = function(downtime) {
    return http.post(['downtime'], downtime);
  };

  this.incrementPrint = function(routePlanId, username) {
    return http.post(['routePlan', routePlanId, 'incrementPrint', username]);
  };

  this.getPlanRoutes = function(routePlanId) {

    var url;

    if ($rootScope.auth.roles.planner) {
        url = ['routePlan', routePlanId];
    } else {
        url = ['customerSystem', customerSystemIdsStr(), 'routePlan', routePlanId];
    }

    return http.get(url).then(function(data) {
      return new RoutePlan(data);
    });
  };

}

module.exports = load;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/load.js
 ** module id = 199
 ** module chunks = 1
 **/